import { render } from "./RegistrarUserComponent.vue?vue&type=template&id=2584d152"
import script from "./RegistrarUserComponent.vue?vue&type=script&lang=js"
export * from "./RegistrarUserComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__